import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { useDispatch, useSelector } from "react-redux";
import { _setFiles } from "../../../../../../store/slices/global.slice";
import { _extractFileDetails } from "../../../../../../utils/common";
// Note: createFeeReceiptPayment import removed as fees.service is not available for HR management system
import Loading from "../../../../../components/skeleton/loading";
import DefaultInput from "../../../../../components/inputs/defaultInput";
import DefaultButton from "../../../../../components/buttons/defaultButton";
import DragAndDropFile from "../../../../../components/inputs/simpleFileUploader";
import { paySalaryByStaff } from "../../../../../../services/workspace/payroll.service";
// import { _extractFileDetails } from "../../../../../utils/common";
// import { _setFiles } from "../../../../../store/slices/global.slice";
// import { createFeeReceiptPayment } from "../../../../../services/workspace/fees.service";

const validationSchema = Yup.object().shape({
  receipt_id: Yup.string().required("Transaction ID / Receipt ID is required"),
  documents: Yup.array()
    .of(Yup.object().required("Documents is required"))
    .min(1, "Documents is required"),
});

const PaySalaryForm = ({
  handleRefresh = () => null,
  setSelected = () => null,
  isModal = false,
  data = null,
  onClose = () => null,
  id,
  selected = {},
  isTerminate = false,
}) => { 
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { fileLoading } = useSelector((state) => state.global);

  useEffect(() => {
    dispatch(_setFiles([]));
  }, []);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      receipt_id: "",
      documents: [],
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => { 
      let payload = {};
      if (isTerminate) { 
        let statusUUid = [];
        selected?.pending_salaries((s) => {
          statusUUid.push(s.uuid);
        });

        payload = {
          documents: _extractFileDetails(values?.documents),
          uuids: statusUUid,
          status: 1,
          receipt_number: values.receipt_id,
        };
      } else {
        payload = {
          documents: _extractFileDetails(values?.documents),
          status: 1,
          receipt_number: values.receipt_id,
        };
      } 
      setIsSubmitting(true);

      paySalaryByStaff(selected.uuid, payload)
        .then((response) => {
          toast.success("Payment created successfully!");
          handleRefresh();
          onClose();
        })
        .catch((error) => {
          toast.error(
            `Failed to create Payment: ${
              error.response?.data?.message || error.message
            }`
          );
          console.error("Error creating payment:", error);
        })
        .finally(() => {
          setIsSubmitting(false);
          setSelected([]);
          if (isModal) {
            onClose();
            handleRefresh();
          }
        });
    },
  });

  return (
    <Fragment>
      {loading ? (
        <Loading />
      ) : (
        <div className={"flex flex-col w-full gap-4 bg-white rounded-md"}>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className={"flex flex-col gap-4 gap-y-2"}>
              <DefaultInput
                label={"Transaction ID / Receipt ID"}
                name="receipt_id"
                value={values.id}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.id && errors.id ? errors.id : ""}
                required
              />
              <div className="col-span-2">
                <DragAndDropFile
                  label={"Upload Document"}
                  onChange={(files) => {
                    setFieldValue("documents", files);
                  }}
                  name={"documents"}
                  limit={1}
                  error={
                    touched.documents && errors.documents
                      ? errors.documents
                      : ""
                  }
                  required
                />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <DefaultButton
                variant="default"
                name={id ? "Edit" : "Submit"}
                type="submit"
                disabled={fileLoading || isSubmitting}
                loading={isSubmitting}
                onClick={handleSubmit}
              />
              {isModal ? (
                <DefaultButton
                  variant="secondary"
                  name={"Cancel"}
                  onClick={onClose}
                />
              ) : null}
            </div>
          </form>
        </div>
      )}
    </Fragment>
  );
};

export default PaySalaryForm;
